export const SELECTION_SAVED_TOAST_ID = 'selection-saved';

// Route state for a navigation made by a save itself: its success toast must survive that move.
export const KEEP_SELECTION_SAVED_TOAST_STATE = { keepSelectionSavedToast: true };

export const shouldKeepSelectionSavedToast = (state: unknown) =>
  !!(state as typeof KEEP_SELECTION_SAVED_TOAST_STATE | undefined)?.keepSelectionSavedToast;
